<template>
  <div class="card-padding card-clickable" @click="goToProjectPage">
    <div class="card-item-wrapper" >
      <v-card
        class="d-inline-block mx-auto card-item"
        width="500"
      >
        <v-img
            :src="require(`@/assets/img/portfolio/${project.image}`)"
            height="220"
            gradient="to bottom, rgba(255,255,255,0), rgba(0,0,0,0.6) 500%"
        />
      </v-card>
    </div>
    <div class="card-descriptor-tag px-5">
      <div class="card-descriptor-tag-content bg-white">
          <div class="larger-text-sizing font-weight-bold">{{ project.title }}</div>
          <div class="standard-text-sizing">{{ project.subtitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PortfolioCard',
    props: {
      project: Object,
    },
    methods: {
      goToProjectPage() {
        this.$router.push({ name: 'Project', params: { id: this.project.id }})
      }
    }
  }
</script>

<style type="scss">
.card-padding {
  display: inline-block;
  padding-bottom: 25px;
  max-width: 100%;
}

@media screen and (min-width: 615px) {
  .card-padding {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

</style>
